import React, { Component } from 'react'
import CustomButton from './CustomButton'
import edit from '../images/edit.svg'
import {Form} from 'react-bootstrap';

export default class OptionItem extends Component {

    constructor(props) {
        super(props);
        let editmode=false;
        if (this.props.editMode) editmode=true;
        this.state = 
        {
            editMode:editmode,
            nameValue:'',
            priceValue:''
        };
    }

    onEditClick(){
        this.setState({editMode:true})
    }

    textHandleChange(e){
        this.setState({[e.target.name]:e.target.value})
    }

    onDoneClick(){
        this.setState({editMode:false})
    }
    
    render() {
        if (!this.state.editMode){
            return (
                <div className="optionItem">
                    <div className="optionItemTitles">
                        <div className="optionItemName">option1option1option1option1option1</div>
                        <div className="optionItemPrice">15 SEK</div>
                    </div>
                    <div style={{width:'50px',height:'50px'}}>
                        <CustomButton title="" imgHeight={30} imgWidth={30} minHeight="50px" img={edit} onClick={this.onEditClick.bind(this)} />
                    </div>
                </div>
            )
        }else{
            return (
                <div className="optionItem" style={{border:'1px solid var(--gray2)',flexDirection:'column'}}>
                    <div className="optionItemTitles">
                        <Form.Control
                            className="inputStyleForm"
                            style={{marginBottom:'5px'}}
                            placeholder="Name"
                            type="text"
                            name="nameValue"
                            onChange={this.textHandleChange}
                            value={this.state.nameValue}
                            disabled={this.state.buttonDisabled}
                        />

                        <Form.Control
                            className="inputStyleForm"
                            style={{marginBottom:'5px'}}
                            placeholder="Price"
                            type="text"
                            name="priceValue"
                            onChange={this.textHandleChange}
                            value={this.state.priceValue}
                            disabled={this.state.buttonDisabled}
                        />
                    </div>
                    <div style={{width:'100%'}}>
                        <CustomButton title="Done" backColor="var(--black1)" img={null} onClick={this.onDoneClick.bind(this)} />
                    </div>
                </div>
            )
        }
        
    }
}
